import { render, staticRenderFns } from "./EmissaoNfse.vue?vue&type=template&id=55ab255a&scoped=true&"
import script from "./EmissaoNfse.vue?vue&type=script&lang=js&"
export * from "./EmissaoNfse.vue?vue&type=script&lang=js&"
import style0 from "./EmissaoNfse.vue?vue&type=style&index=0&id=55ab255a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ab255a",
  null
  
)

export default component.exports